import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import {
	BrowserRouter as Router,
	Route,
	Switch,
	withRouter
} from "react-router-dom";
import "./Layout.scss";

import Dashboard from "./MainContent/Dashboard";
import SideNav from "./SideNav/SideNav";
import TopNav from "./TopNav/TopNav";
import NotFound from "../404/404";
import PermissionsManagerService from "../../services/PermissionManagerService";

class Layout extends Component {
	componentDidMount() {

	}

	render() {

		const { auth } = this.props;
		let dashboardContent = null;
		if (auth.isAuthenticated) {

			const routes = PermissionsManagerService.GetRoutesByUser(auth.user);

			dashboardContent = (
				<>
					<SideNav />
					<div className="right">
						<TopNav />
						<Switch>
							<Route
								exact
								path="/dashboard"
								component={Dashboard}
							/>
							{
								routes.map((route, index) => (
									<Route key={index} exact path={route.path} component={route.component} />
								))
							}
							<Route component={NotFound} />
						</Switch>
					</div>
				</>
			);
		}


		return (
			<Router>
				<div className="wrapper">{dashboardContent}</div>
			</Router>
		);
	}
}

Layout.propTypes = {
	auth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
	auth: state.auth
});

export default withRouter(
	connect(
		mapStateToProps
	)(Layout)
);
